import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

const SECTIONS = [
  { t: "1. Acceptance of Terms", d: "By accessing Wiwi, the intelligent Digital Twin Engine for game backend development, you agree to these Terms & Policy. If you do not agree, do not use the service." },
  { t: "2. Service Description", d: "Wiwi provides AI-assisted backend architecture design, code generation (Golang, PHP), database and caching recommendations, and API connectors. Generated output should be reviewed before production use." },
  { t: "3. Accounts & Security", d: "You authenticate via Google sign-in. You are responsible for safeguarding your API keys. We implement reasonable security measures to protect your workspace and data." },
  { t: "4. Subscriptions & Payments", d: "Paid plans are billed via Stripe. Subscriptions renew until cancelled. Prices are listed in USD. Taxes may apply depending on your jurisdiction." },
  { t: "5. Acceptable Use", d: "You agree not to misuse the service, reverse-engineer the twin, or generate content that violates law or third-party rights." },
  { t: "6. Intellectual Property", d: "You retain ownership of your inputs and generated code. Wiwi retains all rights to the platform, models and underlying technology." },
  { t: "7. Privacy", d: "We process your account data and prompts to deliver the service. We do not sell personal data." },
  { t: "8. Support", d: "Technical support is available 24/24 at kaadeconstruction@gmail.com." },
  { t: "9. Changes", d: "We may update these terms. Continued use after changes constitutes acceptance." },
];

export default function LegalPage() {
  return (
    <div className="bg-background min-h-screen" data-testid="legal-page">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <span className="text-xs font-mono uppercase tracking-widest text-emerald-400">Legal</span>
        <h1 className="mt-3 font-display text-4xl font-bold text-white">Terms &amp; Policy</h1>
        <p className="mt-3 text-slate-500 text-sm font-mono">Last updated: {new Date().toLocaleDateString()}</p>
        <div className="mt-10 space-y-8">
          {SECTIONS.map((s, i) => (
            <section key={s.t} data-testid={`legal-section-${i}`}>
              <h2 className="font-display text-lg font-semibold text-slate-100">{s.t}</h2>
              <p className="mt-2 text-slate-400 leading-relaxed text-sm">{s.d}</p>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
